// extracted by mini-css-extract-plugin
export default {"card":"Card_card__z8HfQ","card_title":"Card_card_title__Da+ol","card_text":"Card_card_text__i8qCd","card_job":"Card_card_job__NqpTj","card_period":"Card_card_period__2iu6v"};